export default __webpack_public_path__ + "static/media/xero_page_two.2412002e.svg";